<template>
  <div>
    <v-card-title>
      <h3 class="headline my-0">{{ $t('Baja de trabajador/a') }}</h3>
    </v-card-title>
    <v-divider light></v-divider>
    <v-card-text>
      <v-select
        v-model="formData.motivo_de_la_baja"
        :disabled="disabled"
        @input="$emit('input', formData)"
        :label="$t('Motivo de la baja')"
        :items="motivosDeLaBaja"
        :rules="[rules.required]"
        required
        item-text="label"
        item-value="value"
        box
        :menu-props="{
          bottom: true,
          'offset-y': true,
        }"
      ></v-select>

      <v-alert class="mb-3" v-model="showMotivoBajaWarning" type="warning">
        Es posible que el periodo de prueba haya finalizado. Espero confirmación por parte del
        departamento laboral.
      </v-alert>

      <v-text-field
        :label="$t('Vacaciones disfrutadas en el presente año (días)')"
        box
        v-model="formData.vacaciones_disfrutadas"
        :rules="[rules.required]"
        required
        :disabled="disabled"
      ></v-text-field>
    </v-card-text>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          motivo_de_la_baja: null,
          vacaciones_disfrutadas: null,
          fecha_de_baja: null,
        };
      },
    },
  },
  data() {
    return {
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
      showMotivoBajaWarning: this.motivoDeLaBajaValue === 'no_superación_de_periodo_de_prueba',
      motivosDeLaBaja: [
        {
          value: 'no_superación_de_periodo_de_prueba',
          label: 'No superación de periodo de prueba',
        },
        { value: 'baja_voluntaria', label: 'Baja voluntaria' },
        { value: 'despido_disciplinario', label: 'Despido disciplinario' },
        { value: 'despido_por_causas_etop', label: 'Despido por causas ETOP' },
        { value: 'finalizacion_obra_y_servicio', label: 'Finalización de Obra/Servicio' },
        {
          value: 'finalizacion_eventual_por_produccion',
          label: 'Finalización de contrato eventual por circunstancias de la producción',
        },
        {
          value: 'finalizacion_interinidad_sustitucion',
          label: 'Finalización de contrato de interinidad/sustitución',
        },
        { value: 'otros', label: 'Otros motivos' },
      ],
    };
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    motivoDeLaBajaValue() {
      return this.formData && this.formData.motivo_de_la_baja
        ? this.formData.motivo_de_la_baja
        : null;
    },
  },
  mounted() {},
  methods: {},
  watch: {
    motivoDeLaBajaValue: {
      handler: function(val) {
        console.log('motivoDelaBajaValue', val);
        this.showMotivoBajaWarning = val === 'no_superación_de_periodo_de_prueba';
      },
    },
  },
};
</script>

<style lang="scss"></style>
